import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { ActionEvent } from '../lib/_types';

export function ImagePreview() {
  const [imageSrc, setImageSrc] = useState<string | undefined>(undefined);

  function closeImagePreview() {
    const vel = document.querySelector('#sonaris-image-preview');
    if (vel) {
      vel.classList.remove('open');
    }
    setImageSrc(undefined);
  }

  useEffect(() => {
    const ctrl = new AbortController();

    window.addEventListener(
      'toggle-image-open',
      (e) => {
        // console.log('window::toggle-image-open', e);
        if (e instanceof ActionEvent) {
          setImageSrc(e.data);
          window.dispatchEvent(new ActionEvent('close-video-preview'));
        }
      },
      ctrl
    );

    window.addEventListener(
      'close-image-preview',
      () => {
        // console.log('window::close-image-preview');
        closeImagePreview();
      },
      ctrl
    );

    return () => {
      ctrl.abort();
    };
  }, []);

  return (
    <AnimatePresence>
      {imageSrc ? (
        <motion.div
          initial={{ scale: 0.7, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 bg-black/60 backdrop-blur-md flex items-center justify-center p-4 pr-[350px]"
          onClick={closeImagePreview}
        >
          <img
            src={imageSrc}
            className="max-w-[70vw] max-h-[80vh] w-auto h-auto rounded-xl shadow-2xl border border-white/5"
          />
        </motion.div>
      ) : (
        <img src={imageSrc} className='hidden' />
      )}
    </AnimatePresence>
  );
}
